import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ProductsComponent } from "./products/products.component";
import { ContactUsComponent } from "./contact-us/contact-us.component";
import { NavDividendsComponent } from "./nav-dividends/nav-dividends.component";
import { KnowledgeCenterComponent } from "./knowledge-center/knowledge-center.component";
import { DownloadsComponent } from "./downloads/downloads.component";
import { CareersComponent } from "./careers/careers.component";
import { DisclaimerComponent } from "./key-policies/disclaimer/disclaimer.component";
import { RiskFactorsComponent } from "./key-policies/risk-factors/risk-factors.component";
import { StatuoryComponent } from "./key-policies/statuory/statuory.component";
import { PrivacyPolicyComponent } from "./key-policies/privacy-policy/privacy-policy.component";
import { CookiePolicyComponent } from "./key-policies/cookie-policy/cookie-policy.component";
import { TermsUseComponent } from "./key-policies/terms-use/terms-use.component";
import { BranchesComponent } from "./branches/branches.component";
import { WriteUsMobileComponent } from "./pop-ups/write-us-mobile/write-us-mobile.component";
import { CallBackMobileComponent } from "./pop-ups/call-back-mobile/call-back-mobile.component";
import { LocateUsMobileComponent } from "./pop-ups/locate-us-mobile/locate-us-mobile.component";
import { NfoComponent } from "./nfo/nfo.component";
import { CeoDeskComponent } from "@root/components/ceo-desk/ceo-desk.component";
import { ArticleDetailsComponent } from "@component/ceo-desk/articles/article-details.component";
import { LatestNewsComponent } from "./latest-news/latest-news.component";
import { MediaComponent } from "./media/media.component";
import { ExecutiveRemunerationComponent } from "./key-policies/statuory/executive-remuneration/executive-remuneration.component";
import { InterviewsComponent } from "@component/ceo-desk/interviews/interviews.component";
import { AdvertisementComponent } from './advertisement/advertisement.component';
import { CeoLibraryComponent } from '@component/ceo-desk/ceo-library/ceo-library.component';
import { LtefProductDetailComponent } from '@component/ltef-product-detail/ltef-product-detail.component';

const routes: Routes = [
  {
    path: "",
    loadChildren: () => import("./home/home.module").then((m) => m.HomeModule),
  },
  {
    path: "products",
    component: ProductsComponent,
    data: {
      breadCrumb: "Products",
      url: "products",
      headerImgPath: "assets/images/banner_products.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Mutual Funds India - Types & Benefits of Mutual Funds Investment | ITI MF",
      meta:"Explore the different types of mutual fund products offered by ITI Mutual Fund. ITI Mutual Fund provides different types of mutual funds, mutual fund calculators, guide to mutual funds, sip investment, tax saving elss mutual funds, etc. Learn about the mutual funds risk, performance & NAVs.",
      keywords: "Best Investment Plan,ULIP,Best ULIP Funds,Best SIP Plans,SIP Calculator,Systematic Investment Plan,SIP,Mutual Fund Calculator,Mutual Funds,Save Tax" 
    },
  },
  {
    path: "products/:id",
    loadChildren: () =>
      import("./product-details/product-details.module").then(
        (m) => m.ProductDetailsModule
      ),
    data: {
      breadCrumb: "Products",
      url: "products",
      headerImgPath: "assets/images/banner_product_small.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false
    },
  },
  {
    path: "distributor",
    loadChildren: () =>
      import("./distributor/distributor.module").then(
        (m) => m.DistributorModule
      ),
    data: {
      breadCrumb: "Distributors",
      url: "distributor",
      headerImgPath: "assets/images/banner_distributor.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Partner with ITI Mutual Fund - Mutual Fund Distributor  | ITI Mutual Fund",
      meta: "ITI Mutual Fund is promoted by The Investment Trust of India Group which has close to 190 offices and over 3000 employees with a presence in all major cities across India.",
    },
  },
  {
    path: "contact",
    component: ContactUsComponent,
    data: {
      breadCrumb: "Contact Us",
      url: "contact",
      headerImgPath: "assets/images/banner_contact.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Contact Us - ITI Mutual Fund",
      meta:
        "For any fund related queries get in touch with ITI Mutual Fund Customer Care Toll-free Number : 1800-266-9603. Board Line Number : +91 022 69153500.",
    },
  },
  {
    path: "about",
    loadChildren: () =>
      import("./about-us/about-us.module").then((m) => m.AboutUsModule),
    data: {
      breadCrumb: "About Us",
      url: "about",
      headerImgPath: "assets/images/banner_about.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "About Us - ITI Mutual Fund",
      meta:
        "For millions of Indians who aspire to a better financial status, we are here to help. Welcome to a mutual fund company where thoughtful and investor centric investment solutions are offered along with robust invest management and research expertise.",
    },
  },
  {
    path: "nav-dividends",
    component: NavDividendsComponent,
    data: {
      breadCrumb: "NAV & IDCW",
      url: "nav-dividends",
      headerImgPath: "assets/images/banners_nav&div.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Latest NAV & IDCW of all ITI Mutual fund schemes | ITI MF",
      meta:"Check latest & historical NAV and IDCW of all ITI Mutual Fund schemes offered by ITI Investment Management here. Explore all latest NAVs or Net Asset Value, dividends & past performances for all mutual funds schemes.",
      keywords: "ITI Equity Fund, ITI Focused Equity Fund, ITI Large Cap Fund, ITI Value Fund, ITI Dynamic Bond Fund, ITI Large and MidCap Fund, ITI Midcap Fund, ITI Tax Advantage Fund, NAV, IDCW"
    },
  },
  {
    path: "knowledge",
    component: KnowledgeCenterComponent,
    data: {
      breadCrumb: "Knowledge Center",
      url: "knowledge",
      headerImgPath: "assets/images/banner_knowledge.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Knowledge Center - ITI Mutual Fund",
      meta:"ITI AMC Knowledge Center is a mutual fund guide which aims at providing information right from the  basics to the latest updates of mutual funds. At ITI Mutual Fund we strongly believe that an educated investor is an empowered investor"
    },
  },
  {
    path: "downloads",
    component: DownloadsComponent,
    data: {
      breadCrumb: "Downloads",
      url: "downloads",
      headerImgPath: "assets/images/banners_download.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Downloads - ITI Mutual Fund",
      meta:
        "Find more information on KYC Non-Individual Form and MF Utility Forms.",
    },
  },
  {
    path: "careers",
    component: CareersComponent,
    data: {
      breadCrumb: "Careers",
      url: "careers",
      headerImgPath: "assets/images/banner_career.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Careers - ITI Mutual Fund",
      meta:
        "In a dynamic and fast-growing economy, mutual funds have opened the door to new, modern and attractive investing opportunities.",
    },
  },
  {
    path: "investors",
    loadChildren: () =>
      import("./investors/investor.module").then((m) => m.InvestorModule),
    data: {
      breadCrumb: "For Investors",
      url: "investors",
      headerImgPath: "assets/images/banner_investor.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Investor Education - A Complete Guide on Mutual Fund | ITI Mutual Fund",
      meta:"Mutual Fund Investment Guide: ITI AMC presents Investor Education Guide for investors to understand mutual funds and make the right investing decisions. Investor Education Awareness Programs by ITI Mutual Fund to help investors make right investing decisions."
    },
  },
  {
    path: "faq",
    loadChildren: () => import("./faq/faq.module").then((m) => m.FaqModule),
    data: {
      breadCrumb: "FAQs",
      url: "faq",
      headerImgPath: "assets/images/banner_branch.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
    },
  },
  {
    path: "risk-factor",
    component: RiskFactorsComponent,
    data: {
      breadCrumb: "Risk Factors",
      url: "risk-factor",
      headerImgPath: "assets/images/banner_knowledge.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Risk Factors - ITI Mutual Fund",
      meta:"Risk Factors · Mutual fund investments are subject to market risks, read all scheme related documents carefully. Mutual Funds and securities investments are subject to market risks and there is no assurance or guarantee that the Fund's objective will be achieved."
    },
  },
  {
    path: "statuory-disclosure",
    component: StatuoryComponent,
    data: {
      breadCrumb: "Statutory Disclosure",
      url: "statuory-disclosure",
      headerImgPath: "assets/images/banner_knowledge.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
    },
  },
  {
    path: "executive-remuneration",
    component: ExecutiveRemunerationComponent,
    data: {
      breadCrumb: "Executive Remuneration",
      url: "executive-remuneration",
      headerImgPath: "assets/images/executive_remuneration_banner.png",
      title: "Statutory Disclosures - ITI Mutual Fund",
      meta:
        "Here's the list of statutory disclosures and ITI mutual fund investment policies by ITI Mutual Fund. Know more!",
    },
  },
  {
    path: "disclaimer",
    component: DisclaimerComponent,
    data: {
      breadCrumb: " Disclaimer",
      url: "disclaimer",
      headerImgPath: "assets/images/banner_knowledge.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Disclaimer - ITI Mutual Fund",
      meta:
        "Disclaimer: ITI Mutual fund investments are subject to market risks. Please read the scheme information and other related documents before investing.",
    },
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent,
    data: {
      breadCrumb: " Privacy Policy",
      url: "privacy-policy",
      headerImgPath: "assets/images/banner_knowledge.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Privacy Policy - ITI Mutual Fund",
      meta:
        "We, at ITI Mutual Fund, respect investors right to privacy. We recognise that the lawful and correct treatment of personal data is very important to maintain investor's confidence in ourselves.",
    },
  },
  {
    path: "cookie-policy",
    component: CookiePolicyComponent,
    data: {
      breadCrumb: " Cookie Policy",
      url: "cookie-policy",
      headerImgPath: "assets/images/banner_knowledge.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Cookie Policy - ITI Mutual Fund",
      meta:
        "ITI cookie policy outlines how we use cookies and how to manage and delete them.",
    },
  },
  {
    path: "terms-of-use",
    component: TermsUseComponent,
    data: {
      breadCrumb: " Terms of Use Policy",
      url: "terms-of-use",
      headerImgPath: "assets/images/banner_knowledge.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Cookie Policy - ITI Mutual Fund",
      meta:
        "ITI cookie policy outlines how we use cookies and how to manage and delete them.",
    },
  },
  {
    path: "karvy-branches",
    component: BranchesComponent,
    data: {
      breadCrumb: " KFintech Branches",
      url: "karvy-branches",
      headerImgPath: "assets/images/banner_branch.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "KFinTech Branches - ITI Mutual Fund",
      meta: "Branch offices of KFin Technologies Limited",
    },
  },
  {
    path: "amc-branches",
    component: BranchesComponent,
    data: {
      breadCrumb: " ITI AMC Branches",
      url: "amc-branches",
      headerImgPath: "assets/images/banner_branch.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "ITI AMC Branches - ITI Mutual Fund",
      meta: "Reach out to our wide network of branches, distributors and agents, to invest in mutual funds - ITI AMC"
    },
  },
  {
    path: "locate-advisor",
    component: BranchesComponent,
    data: {
      breadCrumb: "Locate your Advisor",
      url: "locate-advisor",
      headerImgPath: "assets/images/banner_branch.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
      title: "Locate your Advisor - ITI Mutual Fund",
      meta: ""
    },
  },
  {
    path: "write-to-us",
    component: WriteUsMobileComponent,
    data: {
      breadCrumb: " Write to us",
      url: "write-to-us",
      headerImgPath: "assets/images/banner_branch.png",
      skipBreadCrumb: true,
      hasCta: false,
      hasCarousel: false,
      title: "Write Us - ITI Mutual Fund",
      meta: ""
    },
  },
  {
    path: "call-back",
    component: CallBackMobileComponent,
    data: {
      breadCrumb: "Call Back",
      url: "call-back",
      headerImgPath: "assets/images/banner_branch.png",
      skipBreadCrumb: true,
      hasCta: false,
      hasCarousel: false,
    },
  },
  {
    path: "locate-us",
    component: LocateUsMobileComponent,
    data: {
      breadCrumb: "Locate us",
      url: "locate-us",
      headerImgPath: "assets/images/banner_branch.png",
      skipBreadCrumb: true,
      hasCta: false,
      hasCarousel: false,
    },
  },
  {
    path: "nfo",
    component: NfoComponent,
    data: {
      breadCrumb: "NFO",
      url: "nfo",
      headerImgPath: "",
      skipBreadCrumb: true,
      hasCta: false,
      hasCarousel: true,
      title: "NFO - ITI Mutual Fund",
      meta: ""
    },
  },
  {
    path: "ceo-desk",
    component: CeoDeskComponent,
    data: {
      breadCrumb: "CEO's Desk",
      url: "ceo-desk",
      headerImgPath: "",
      skipBreadCrumb: true,
      hasCta: false,
      hasCarousel: true,
      title: "From CEO's Desk - ITI Mutual Fund",
      meta: "Check what ITI Mutual Fund CEO Mr. George Joseph has to share with mutual fund investors right here. Visit us and start your investing in Mutual Funds."
    },
  },
  {
    path: "ceo-desk/articles",
    component: ArticleDetailsComponent,
    data: {
      breadCrumb: "CEO's Desk",
      url: "ceo-desk",
      headerImgPath: "assets/images/banner_branch.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
    },
  },
  {
    path: "ceo-desk/library",
    component: CeoLibraryComponent,
    data: {
      breadCrumb: "CEO's Library",
      url: "ceo-desk/library",
      headerImgPath: "assets/images/banner_branch.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
    },
  },
  {
    path: "ceo-desk/interview",
    component: InterviewsComponent,
    data: {
      breadCrumb: "CEO-Interview",
      url: "ceo-desk/interview",
      headerImgPath: "assets/images/banner_branch.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
    },
  },
  {
    path: "latest-news",
    component: LatestNewsComponent,
    data: {
      breadCrumb: "Latest News",
      url: "latest-news",
      headerImgPath: "assets/images/latest_news_banner.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
    },
  },
  {
    path: "media",
    component: MediaComponent,
    data: {
      breadCrumb: "Media",
      url: "media",
      headerImgPath: "assets/images/media_banner.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
    },
  },
  {
    path: "advertisement",
    component: AdvertisementComponent,
    data: {
      breadCrumb: "Advertisement",
      url: "advertisement",
      headerImgPath: "assets/images/media_banner.png",
      skipBreadCrumb: false,
      hasCta: false,
      hasCarousel: false,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ComponentRoutingModule {}
